import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';

import theme from 'assets';
import './assets/sites_cookiebot.css';
import 'helpers/Extensions';

import { AxiosHandlerProvider, Routes } from './components';
import { AuthProvider } from 'helpers/services';

import { setLocale } from 'yup';
import ApplicationUserProvider from 'helpers/services/ApplicationUserContext';

setLocale({
  mixed: {
    default: '${path} value not valid',
    required: '${path} is mandatory field'
  },
  string: {
    min: '${path} must have less than ${min} characters',
    max: '${path} can\'t have more than ${max} characters',
    length: '${path} must have ${length} characters'
  },
  number: {
    min: 'Value must be at least ${min}',
    max: 'Value can\'t be more than ${max}',
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
        <SnackbarProvider preventDuplicate>
          <CssBaseline />
          <BrowserRouter>
            <AuthProvider>
              <AxiosHandlerProvider />
              <ApplicationUserProvider>
                <Routes />
              </ApplicationUserProvider>
            </AuthProvider>
          </BrowserRouter>
        </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
